<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :_post-id="_postId"
      :board="board"
      :fieldReadonly="board.readonly"
      :is-print="isPrint || board.readonly"
      :options="[{ type: 'text', label: '문서번호', readonly: true, visibleWhenValue: true }]"
      vislbleAlert
    />

    <!-- 문서정보 -->
    <write-grid-container
      title="문서정보"
      v-model="form.문서정보"
      :options="{
        dataTypes: ['select_보안등급', 'select_보존년한'],
        labels: ['보안등급', '보존년한'],
        values: ['보안등급', '보존년한'],
      }"
      class="page-break mt-7"
    >
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint || board.readonly">
          <div class="print-input">{{ form.문서정보[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <custom-option-selector v-if="dataType === 'select_보안등급'" class="w-full" v-model="form.문서정보[value]" :options="['사내', '그룹사내', '팀내', '제한']" />
          <custom-option-selector
            v-else-if="dataType === 'select_보존년한'"
            class="w-full"
            v-model="form.문서정보[value]"
            :options="[
              { text: '1년', value: 1 },
              { text: '3년', value: 3 },
              { text: '5년', value: 5 },
              { text: '7년', value: 7 },
              { text: '10년', value: 10 },
              { text: '영구', value: -1 },
            ]"
          />
          <ml-input v-else class="w-full" v-model="form.문서정보[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!-- 평가정보 -->
    <write-grid-container
      title="평가정보"
      v-model="form.평가정보"
      :options="{
        dataTypes: ['date', 'text', 'radio'],
        labels: ['평가일', '담당자', '직영/협력'],
        values: ['평가일', '담당자', '직영협력'],
      }"
      class="page-break mt-7"
    >
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint || board.readonly">
          <radio-group v-if="dataType === 'radio'" class="w-full" :items="['직영', '협력']" flex :readonly="true" v-model="form.평가정보[value]" />
          <div v-else class="print-input">{{ form.평가정보[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.평가정보[value]" />
          <radio-group v-else-if="dataType === 'radio'" class="w-full" :items="['직영', '협력']" flex v-model="form.평가정보[value]" />
          <ml-input v-else class="w-full" v-model="form.평가정보[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!-- 에너지검토 분류 -->
    <write-grid-container
      title="에너지검토 분류"
      v-model="form.에너지검토분류"
      :options="{
        dataTypes: ['readonly', 'readonly', 'readonly', 'readonly'],
        labels: ['팀명', '공장명', '공정명', '활동명'],
        values: ['팀명', '공장명', '공정명', '활동명'],
      }"
      class="page-break mt-7"
    >
      <template #topRight>
        <select893-button v-if="!(isPrint || board.readonly)" v-model="form.에너지검토분류.raw" @input="onSelectProcess" />
      </template>

      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint">
          <div class="print-input">{{ form.에너지검토분류[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <ml-input class="w-full" readonly v-model="form.에너지검토분류[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!-- 에너지 평가 -->
    <table-custom
      class="mt-7"
      customThead
      :board="board"
      :is-print="isPrint"
      :tableData="[
        { id: 'no', width: '40', title: 'No.', type: 'no' },
        { id: '설비명', width: '140', title: '장비명', type: 'text' },
        { id: '사용에너지', width: '92', title: '사용<br>에너지', type: 'select', selectData: ['LNG', '전력', '스팀'] },
        { id: '단위', width: '54', title: '단위', type: 'customType', className: 'items-center' },
        { id: '계측가능여부', width: '92', title: '계측가능<br>여부', type: 'select', selectData: ['N', 'Y'] },
        { id: '용량', width: '92', title: '용량<br>(단위/hr)', type: 'text' },
        { id: '수량', width: '92', title: '수량', type: 'number' },
        { id: '평균가동시간', width: '126', title: '평균<br>가동시간<br>(시간/년)', type: 'text' },
        { id: '계측값', width: '126', title: '계측값<br>(사용예상량)', type: 'text' },
        { id: '환산량', width: '100', title: '환산량<br>(Toe/년)', type: 'customType', className: 'items-center' },

        { id: '평가품목_사용량_항목', width: '117', title: '항목', type: 'customType', selectData: ['1,000 toe 이상', '200 toe 이상 1,000 toe 미만', '200 toe 미만'] },
        { id: '평가품목_사용량_점수', width: '70', title: '점수', type: 'fixed-text', defaultValue: 0 },
        { id: '평가품목_개선가능성_항목', width: '117', title: '항목', type: 'customType', selectData: ['30% 이상', '10% 이상 30% 미만', '10% 미만'] },
        { id: '평가품목_개선가능성_점수', width: '70', title: '점수', type: 'fixed-text', defaultValue: 0 },
        { id: '평가품목_시급성_항목', width: '117', title: '항목', type: 'customType', selectData: ['1년 미만', '1년 이상 3년 미만', '3년 이상'] },
        { id: '평가품목_시급성_점수', width: '70', title: '점수', type: 'fixed-text', defaultValue: 0 },
        { id: '평가품목_평가점수', width: '81', title: '평가점수', type: 'fixed-text', defaultValue: 0 },
        { id: '평가품목_등급', width: '70', title: '등급', type: 'customType', className: 'items-center' },
        { id: '평가품목_중요에너지등록부분류', width: '120', title: '중요에너지등록부<br>분류', type: 'customType', className: 'items-center' },
        { id: '평가품목_비고', width: '120', title: '비고', type: 'text' },
      ]"
      :mobile="['설비명', '사용에너지', '단위']"
      v-model="form.에너지평가"
    >
      <template #colgroup="{ isMobile }">
        <col width="40" />
        <col width="40" />
        <col width="140" />
        <col width="92" />
        <col width="54" />
        <col v-if="!isMobile" width="92" />
        <col v-if="!isMobile" width="92" />
        <col v-if="!isMobile" width="92" />
        <col v-if="!isMobile" width="126" />
        <col v-if="!isMobile" width="126" />
        <col v-if="!isMobile" width="100" />
        <col v-if="!isMobile" width="117" />
        <col v-if="!isMobile" width="70" />
        <col v-if="!isMobile" width="117" />
        <col v-if="!isMobile" width="70" />
        <col v-if="!isMobile" width="117" />
        <col v-if="!isMobile" width="70" />
        <col v-if="!isMobile" width="81" />
        <col v-if="!isMobile" width="70" />
        <col v-if="!isMobile" width="120" />
        <col v-if="!isMobile" width="120" />
      </template>
      <template #customTitle>
        <div class="flex flex-wrap items-center justify-start gap-3">
          <h5><i class="dot"></i>에너지 평가</h5>
          <span class="cursor-pointer flex gap-1 items-center" style="color: #7e72f2" @click="showHowToWrite = true">
            <feather-icon icon="AlertCircleIcon" class="w-5 h-5" />
            작성방법
          </span>
          <div class="ml-auto"></div>
        </div>
      </template>
      <template #customHead="{ isMobile, allCheckValue, onClickAllCheck }">
        <tr v-if="isMobile">
          <!-- 테이블 헤더내 전체선택-->
          <th class="text-center" style="padding: 0">
            <vs-checkbox class="justify-center mx-0" :value="allCheckValue" @click.native="onClickAllCheck" />
          </th>
          <th>No.</th>
          <th>설비명</th>
          <th>사용<br />에너지</th>
          <th></th>
        </tr>
        <tr v-if="!isMobile">
          <!-- 테이블 헤더내 전체선택-->
          <th rowspan="3" class="text-center" style="padding: 0">
            <vs-checkbox class="justify-center mx-0" :value="allCheckValue" @click.native="onClickAllCheck" />
          </th>
          <th colspan="10">에너지사용</th>
          <th colspan="10">평가품목</th>
        </tr>
        <tr v-if="!isMobile">
          <th rowspan="2">No.</th>
          <th rowspan="2">설비명</th>
          <th rowspan="2">사용<br />에너지</th>
          <th rowspan="2">단위</th>
          <th rowspan="2">계측가능<br />여부</th>
          <th rowspan="2">용량<br />(단위/hr)</th>
          <th rowspan="2">수량</th>
          <th rowspan="2">평균<br />가동시간<br />(시간/년)</th>
          <th rowspan="2">계측값<br />(사용예상량)</th>
          <th rowspan="2">환산량<br />(Toe/년)</th>
          <th colspan="2">사용량</th>
          <th colspan="2">개선 가능성</th>
          <th colspan="2">시급성</th>
          <th rowspan="2">평가점수</th>
          <th rowspan="2">등급</th>
          <th rowspan="2">중요에너지등록부<br />분류</th>
          <th rowspan="2">비고</th>
        </tr>
        <tr v-if="!isMobile">
          <th>항목</th>
          <th>점수</th>
          <th>항목</th>
          <th>점수</th>
          <th>항목</th>
          <th>점수</th>
        </tr>
      </template>
      <template #customType="{ trData, id, index, value }">
        <div v-if="id === '단위'">
          {{ ["LNG", "전력", "스팀"].indexOf(trData.사용에너지) > -1 ? ["Nm³", "kWh", "Ton"][["LNG", "전력", "스팀"].indexOf(trData.사용에너지)] : "" }}
        </div>
        <div v-if="id === '환산량'">
          {{ calculate_환산량(trData) }}
        </div>
        <div v-if="id === '평가품목_사용량_항목'">
          <vs-select class="w-full" autocomplete v-model="trData[id]" :disabled="isPrint || board.readonly" @change="onChangeSelect(index, id)">
            <vs-select-item v-for="item in ['1,000 toe 이상', '200 toe 이상 1,000 toe 미만', '200 toe 미만']" :key="item" :value="item" :text="item" />
          </vs-select>
        </div>
        <div v-if="id === '평가품목_개선가능성_항목'">
          <vs-select class="w-full" autocomplete v-model="trData[id]" :disabled="isPrint || board.readonly" @change="onChangeSelect(index, id)">
            <vs-select-item v-for="item in ['30% 이상', '10% 이상 30% 미만', '10% 미만']" :key="item" :value="item" :text="item" />
          </vs-select>
        </div>
        <div v-if="id === '평가품목_시급성_항목'">
          <vs-select class="w-full" autocomplete v-model="trData[id]" :disabled="isPrint || board.readonly" @change="onChangeSelect(index, id)">
            <vs-select-item v-for="item in ['1년 미만', '1년 이상 3년 미만', '3년 이상']" :key="item" :value="item" :text="item" />
          </vs-select>
        </div>
        <div v-else-if="id === '평가품목_등급'">
          <ml-input readonly style="color: #ea5455" :value="value" />
        </div>
        <div v-else-if="id === '평가품목_중요에너지등록부분류'" class="flex justify-center items-center">
          <vs-checkbox :disabled="Number(trData['평가품목_평가점수']) >= 18 || Number(trData['평가품목_사용량_점수']) === 3 || isPrint || board.readonly" :checked="value" @change="onChangeCheck(index, id)" />
        </div>
      </template>
    </table-custom>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
    <popup-how-to-write v-model="showHowToWrite" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PopupHowToWrite from "@/views/boards/single-page/901/PopupHowToWrite.vue";
import { required } from "vuelidate/lib/validators";
import Select893Button from "@/views/boards/single-page/893/Select893Button.vue";

export default {
  components: {
    Select893Button,
    PopupHowToWrite,
    TableCustom,
    DateSelector,
    RadioGroup,
    CustomOptionSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    _postId: [String, Number], // PopupPostView 등에서 postId를 명시적으로 전달할 때 사용
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      showHowToWrite: false,
      form: {
        stdInfo: {},
        문서정보: {
          보안등급: "팀내",
          보존년한: 3,
        },
        평가정보: {},
        에너지검토분류: {
          raw: undefined,
        },
        에너지평가: [],

        fileList: [],
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
        // 뷰어/읽기 시 저장된 body에 등급·중요에너지등록부분류가 없을 수 있으므로 계산 한 번 실행
        if (value && value.에너지평가 && value.에너지평가.length > 0) {
          this.$nextTick(() => {
            this.calculate_에너지평가_평가품목(0);
          });
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },

    // 에너지평가 계산
    // 중요에너지등록부분류 : 평가점수 18점 이상 인경우 자동으로 체크, 18점 미만인 경우 사용자가 체크 가능 이므로,
    // watch 에 넣지 않고 별도로 처리
    calculate_에너지평가_평가품목(index) {
      const value = this.form;
      if (value.에너지평가 && value.에너지평가.length > 0) {
        for (const 에너지평가 of value.에너지평가) {
          // 평가품목_사용량_점수
          if (에너지평가["평가품목_사용량_항목"] === "1,000 toe 이상") {
            에너지평가["평가품목_사용량_점수"] = 3;
          } else if (에너지평가["평가품목_사용량_항목"] === "200 toe 이상 1,000 toe 미만") {
            에너지평가["평가품목_사용량_점수"] = 2;
          } else if (에너지평가["평가품목_사용량_항목"] === "200 toe 미만") {
            에너지평가["평가품목_사용량_점수"] = 1;
          } else {
            에너지평가["평가품목_사용량_점수"] = 0;
          }

          // 평가품목_개선가능성_점수
          if (에너지평가["평가품목_개선가능성_항목"] === "30% 이상") {
            에너지평가["평가품목_개선가능성_점수"] = 3;
          } else if (에너지평가["평가품목_개선가능성_항목"] === "10% 이상 30% 미만") {
            에너지평가["평가품목_개선가능성_점수"] = 2;
          } else if (에너지평가["평가품목_개선가능성_항목"] === "10% 미만") {
            에너지평가["평가품목_개선가능성_점수"] = 1;
          } else {
            에너지평가["평가품목_개선가능성_점수"] = 0;
          }

          // 평가품목_시급성_점수
          if (에너지평가["평가품목_시급성_항목"] === "1년 미만") {
            에너지평가["평가품목_시급성_점수"] = 3;
          } else if (에너지평가["평가품목_시급성_항목"] === "1년 이상 3년 미만") {
            에너지평가["평가품목_시급성_점수"] = 2;
          } else if (에너지평가["평가품목_시급성_항목"] === "3년 이상") {
            에너지평가["평가품목_시급성_점수"] = 1;
          } else {
            에너지평가["평가품목_시급성_점수"] = 0;
          }

          // 평가품목_평가점수
          에너지평가["평가품목_평가점수"] = 에너지평가["평가품목_사용량_점수"] * 에너지평가["평가품목_개선가능성_점수"] * 에너지평가["평가품목_시급성_점수"];
          // 평가품목_등급
          에너지평가["평가품목_등급"] = 에너지평가["평가품목_평가점수"] >= 18 || 에너지평가["평가품목_사용량_점수"] === 3 ? "M" : "-";

          // 평가품목_중요에너지등록부분류 (평가점수 18점 이상 또는 사용량 3점이면 자동 체크, 해제 불가)
          에너지평가["평가품목_중요에너지등록부분류"] = 에너지평가["평가품목_평가점수"] >= 18 || 에너지평가["평가품목_사용량_점수"] === 3;
        }
      }
    },

    // 환산량 계산
    calculate_환산량(trData) {
      const toNum = (v) => parseFloat(String(v || 0).replace(/,/g, "")) || 0;

      let 사용량 = 0;
      if (trData.계측가능여부 === "Y") {
        사용량 = toNum(trData.계측값);
      } else if (trData.계측가능여부 === "N") {
        사용량 = toNum(trData.용량) * toNum(trData.수량);
      }

      let 환산량 = 0;
      if (trData.사용에너지 === "LNG") {
        환산량 = (사용량 * 1.019) / 1000;
      } else if (trData.사용에너지 === "전력") {
        환산량 = (사용량 * 0.229) / 1000;
      } else if (trData.사용에너지 === "스팀") {
        환산량 = 사용량 * 0.0539;
      }

      return 환산량.toFixed(6);
    },

    // 문서 우측 상단 버튼들
    // 커스텀 버튼을 넣고 싶은 경우, tab/Index.vue 의 writeApprovalButtonsTemplate 함수를 참고하여 Json 작성
    // setApprovalButtons(template) {
    //   const 개정 = JSON.parse(JSON.stringify(template.resend))
    //   개정.content = "개정";
    //   개정.shouldShow.custom = ["approved"].indexOf(this.board.statusCode) > -1 // 승인된 경우에만 개정 가능
    //   개정.emits.click = (func) => {
    //     //  개정시 데이터 변경 (num: +1, date: new Date())
    //     this.form.revision.num += 1;
    //     this.form.revision.date = new Date();
    //     this.form.위험성평가정보.평가일자 = new Date().format("yyyy-MM-dd");
    //
    //     func.resend("개정 할 경우\n기존 문서는 유지되고, 내용이 복사되어 임시저장 됩니다.\n개정 하시겠습니까?");
    //   }
    //
    //   const saveFunc = template.save.emits.click
    //   template.save.emits.click = (func) => {
    //
    //     if (this.is위험도20) {
    //       this.popup.warning20 = true;
    //     } else {
    //       saveFunc(func)
    //     }
    //   }
    //   return [ 개정, template.resend, template.print, template.delete, template.move, template.save ]
    // },

    onSelectProcess(raw) {
      this.form.에너지검토분류.팀명 = raw.팀명;
      this.form.에너지검토분류.공장명 = raw.공장명;
      this.form.에너지검토분류.공정명 = raw.공정명;
      // this.form.에너지검토분류.상태 = raw.상태
      this.form.에너지검토분류.활동명 = raw.활동명;
    },

    onChangeCheck(index, id) {
      this.$nextTick(() => {
        this.form.에너지평가[index][id] = !this.form.에너지평가[index][id];
        this.$forceUpdate();
      });
    },

    onChangeSelect(index, id) {
      const item = this.form.에너지평가[index][id];
      this.$nextTick(() => {
        this.form.에너지평가[index][id] = item;
        this.calculate_에너지평가_평가품목(index);
        this.$forceUpdate();
      });
    },

    getRating(point) {
      if (point >= 25) return { name: "H", color: "#E42728" };
      else if (point >= 15) return { name: "M", color: "#EA5455" };
      else if (point >= 5) return { name: "L", color: "#FF9F43" };
      else return { name: "N", color: "#28C76F" };
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;

  thead {
    z-index: 0 !important;
  }
  th {
    background: #f9f9f9;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;

    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 16px 0;
    text-align: center;
  }
  td {
    background: #fff !important;
    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 6px;
  }
}
</style>
